var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYaSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.326 5.884a9.817 9.817 0 0 1 .092.108c.772.912 3.315 4.16 2.673 5.315a.657.657 0 0 1-.103.139l-.009.009-.01.01-.01.009a.663.663 0 0 1-.559.165c-.382-.045-.838-.314-1.319-.598l-.088-.052c-.608-.357-1.515-1.2-2.447-2.135a75.034 75.034 0 0 1-.843-.862l2.623-2.108Zm.713 6.515a12.504 12.504 0 0 1-.655-.376c-.52-.305-1.125-.825-1.702-1.363A51.507 51.507 0 0 1 5.84 8.825l-.912-.946 3.445-2.768-.01-.013.917-.726c1.17-.925 1.845-1.544 2.226-1.94a5.37 5.37 0 0 0-.218-.161l-.001-.002a5.208 5.208 0 0 0-1.408-.726l-.02-.006-.021-.008c-2.13-.77-4.684-.154-6.196 1.503l-.01.01c-2.042 2.19-2.077 5.679-.02 7.902 1.676 1.802 4.262 2.302 6.428 1.455Zm1.764.426c-2.81 1.879-6.696 1.491-9.071-1.065-2.49-2.69-2.445-6.89.022-9.536C4.6.2 7.667-.533 10.246.4c.622.2 1.2.511 1.733.89.378.266.734.577 1.068.933 0 0 .36.381-2.79 2.903l-.234.187.067.089.038.043c.23.265.45.53.658.794 1.908 2.428 2.8 4.759 2.083 5.676a.621.621 0 0 1-.111.133l-.112.111a6.875 6.875 0 0 1-.843.665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaSplit);
export default __webpack_public_path__ + "static/media/yaSplit.daf5d58f4f72e7fed32755837b941abb.svg";
export { ForwardRef as ReactComponent };